export default {
  "preAllocated": "Pre-allocated",
  "adminDividesSpacePerUserLimitsGateUploadsTotal": "Admin divides space — per-user limits gate uploads, total is a hard ceiling.",
  "firstCome": "First-come",
  "sharedPoolOverAllowanceUploadsCanBeReservedUntil": "Shared pool — over-allowance uploads can be reserved until space frees.",
  "storageSettingsSaved": "Storage settings saved",
  "saveFailed": "Save failed",
  "retry": "Retry",
  "storageLimits": "Storage limits",
  "allowance": "Allowance",
  "totalAMCAllowance": "Total AMC allowance",
  "0Unlimited": "0 (unlimited)",
  "currentlyUsed": "Currently used",
  "unlimited": "/ unlimited",
  "usageAlreadyExceedsThisAllowance": "Usage already exceeds this allowance.",
  "perFileLimit": "Per-file limit",
  "maximumUploadSize": "Maximum upload size",
  "theLargestSingleFileAUserCanUploadTo": "The largest single file a user can upload to the AMC.",
  "noUploadRestraint": "No Upload Restraint",
  "noUploadRestraintAllowUnlimitedUploadSize": "No upload restraint (allow unlimited upload size)",
  "maximumUploadSizeUnit": "Maximum upload size unit",
  "policy": "Policy",
  "quotaPolicy": "Quota policy",
  "unsavedChanges": "Unsaved changes",
  "saveChanges": "Save changes",
  "deleteFailed": "Delete failed",
  "backupFailed": "Backup failed",
  "deleteBackup": "Delete backup?",
  "deleteBackup2": "Delete backup",
  "backupDeleted": "Backup deleted",
  "deleteAllBackups": "Delete all backups?",
  "deleteAll": "Delete all",
  "application": "Application",
  "owner": "Owner",
  "files": "Files",
  "spaceUsed": "Space used",
  "latestBackup": "Latest backup",
  "backUpNow": "Back up now",
  "configOnly": "Config Only",
  "view": "View",
  "download": "Download",
  "delete": "Delete",
  "noApplicationBackupsYet": "No application backups yet",
  "filterBackupsByUser": "Filter backups by user",
  "allUsersSearchToFilter": "All users — search to filter",
  "backUpAnApp": "Back up an app",
  "refresh": "Refresh",
  "logoUpdated": "Logo updated",
  "updateFailed": "Update failed",
  "logoResetToDefault": "Logo reset to default",
  "resetFailed": "Reset failed",
  "replaceLogo": "Replace logo",
  "uploadAnImageToOverrideTheLogoResetRestores": "Upload an image to override the logo. Reset restores the bundled default.",
  "resetToDefault": "Reset to default",
  "cancel": "Cancel",
  "saving": "Saving…",
  "searchApps": "Search apps…",
  "searchApplicationLogos": "Search application logos",
  "loadingApplicationLogos": "Loading application logos…",
  "noAppsMatchYourSearch": "No apps match your search.",
  "searchAssets": "Search assets...",
  "allScopes": "All Scopes",
  "global": "Global",
  "page": "Page",
  "allTypes": "All Types",
  "images": "Images",
  "pDFs": "PDFs",
  "filterByUploader": "Filter by uploader",
  "gridView": "Grid view",
  "listView": "List view",
  "upload": "Upload",
  "assetUploaded": "Asset uploaded",
  "youReInLine": "You're in line",
  "uploadFailed": "Upload failed",
  "assetUpdated": "Asset updated",
  "deleteAsset": "Delete asset?",
  "assetDeleted": "Asset deleted",
  "noAssetsFound": "No assets found",
  "uploadYourFirstAsset": "Upload your first asset",
  "accessStats": "Access stats",
  "preparingThisVideoForBrowserPlayback": "Preparing this video for browser playback",
  "processing": "Processing",
  "attachedToASpecificPageRatherThanTheShared": "Attached to a specific page rather than the shared library",
  "pageAsset": "Page asset",
  "share": "Share",
  "setAsBrandAsset": "Set as brand asset",
  "edit": "Edit",
  "uRLCopied": "URL copied",
  "copyFailed": "Copy failed",
  "clipboardAccessWasDenied": "Clipboard access was denied.",
  "copyURL": "Copy URL",
  "editAsset": "Edit Asset",
  "altText": "Alt Text",
  "describeTheImage": "Describe the image...",
  "caption": "Caption",
  "optionalCaption": "Optional caption...",
  "saving2": "Saving...",
  "zoomOut": "Zoom out",
  "zoomIn": "Zoom in",
  "resetZoomToFit": "Reset zoom to fit",
  "permanent": "permanent",
  "copyLink": "Copy link",
  "copyShareLink": "Copy share link",
  "revoke": "Revoke",
  "revokeShareLink": "Revoke share link",
  "loadingShareLinks": "Loading share links...",
  "noShareLinksYetForThisFile": "No share links yet for this file.",
  "last14Days": "Last 14 days",
  "noViewsYet": "No views yet",
  "statsAppearOnceThisAssetIsViewedOrDownloaded": "Stats appear once this asset is viewed or downloaded.",
  "views": "Views",
  "downloads": "Downloads",
  "viewers": "Viewers",
  "lastViewed": "Last viewed",
  "recentViewers": "Recent viewers",
  "previewNotShowing": "Preview not showing?",
  "openDownload": "Open download",
  "preparingThisVideoForPlayback": "Preparing this video for playback…",
  "thisUsuallyTakesAMomentThePlayerWillAppear": "This usually takes a moment. The player will appear automatically.",
  "close": "Close",
  "closeViewer": "Close viewer",
  "previousFile": "Previous file",
  "nextFile": "Next file",
  "resetAvatar": "Reset avatar?",
  "reset": "Reset",
  "avatarReset": "Avatar reset",
  "searchUsers": "Search users…",
  "searchAvatarsByUser": "Search avatars by user",
  "user": "user",
  "loadingAvatars": "Loading avatars…",
  "unableToLoadThisFileDownloadItToView": "Unable to load this file. Download it to view the contents.",
  "downloadFile": "Download file",
  "unsupportedFile": "Unsupported file",
  "emailLogosMustBeAnImage": "Email logos must be an image.",
  "removeEmailLogo": "Remove email logo",
  "theBotAvatarMustBeAPNGJPGOr": "The bot avatar must be a PNG, JPG, or WebP image.",
  "resetToDefaultAvatar": "Reset to default avatar",
  "resetBotAvatarToDefault": "Reset bot avatar to default",
  "pleaseTryAgain": "Please try again.",
  "brandAssets": "Brand Assets",
  "promoteAnyLibraryImageIntoASlotViaIts": "Promote any library image into a slot via its crown action; upload email logos here.",
  "brandingSettings": "Branding settings",
  "emailLogosAppearInOutgoingEmailHeaders": "Email logos appear in outgoing email headers.",
  "emailSettingsAdvanced": "Email Settings → Advanced",
  "backUpAnApplication": "Back up an application",
  "selectTheBackupOwner": "Select the backup owner",
  "searchByUsernameOrEmail": "Search by username or email",
  "selectAnOwnerToListTheirInstalledApplications": "Select an owner to list their installed applications.",
  "loadingApplications": "Loading applications…",
  "noInstalledApplicationsFound": "No installed applications found.",
  "selectAnApplicationToBackUp": "Select an application to back up",
  "backupType": "Backup type",
  "creatingTheBackupLargeAppsCanTakeSeveralMinutes": "Creating the backup — large apps can take several minutes. You can close this and keep working; we’ll let you know when it’s done.",
  "createBackup": "Create backup",
  "active": "Active",
  "saved": "Saved",
  "setActive": "Set active",
  "pleaseChooseAnImage": "Please choose an image.",
  "avatarUpdated": "Avatar updated",
  "avatarSetAsActive": "Avatar set as active",
  "failedToSetActive": "Failed to set active",
  "deleteAvatar": "Delete avatar?",
  "thisAvatarWillBePermanentlyRemovedFromYourCollection": "This avatar will be permanently removed from your collection.",
  "avatarDeleted": "Avatar deleted",
  "dragDropAnImageOr": "Drag and drop an image, or use the button below.",
  "yourPreviousAvatarsAreKeptHereSoYouCan": "Your previous avatars are kept here so you can switch back anytime.",
  "youHavenTUploadedAnyAvatarsYet": "You haven't uploaded any avatars yet.",
  "storagePathCopied": "Storage path copied",
  "couldnTCopyThePath": "Couldn't copy the path",
  "loadingStorageUsage": "Loading storage usage…",
  "storageUsageUnavailable": "Storage usage unavailable",
  "filesYouUploadHereLiveInThisFolderInside": "Files you upload here live in this folder inside your home directory and are reachable over SFTP/FTP. They count against your personal storage quota.",
  "browseOverSFTPAt": "Browse over SFTP at",
  "sFTPPath": "SFTP path",
  "copyStoragePath": "Copy storage path",
  "chooseTheBrandingSlotThisImageShouldFillEach": "Choose the branding slot this image should fill. Each slot has its own format requirements — the file is validated against the slot when applied.",
  "brandingSlot": "Branding slot",
  "pictureInPicture": "Picture in picture",
  "videoPlayer": "Video player",
  "downloadVideo": "Download video",
  "audioPlayer": "Audio player",
  "downloadAudio": "Download audio",
  "seek": "Seek",
  "volume": "Volume",
  "playbackSpeed": "Playback speed",
  "spaceAvailableUploadNow": "Space available — upload now",
  "queued": "Queued",
  "offered": "Offered",
  "fulfilled": "Fulfilled",
  "cancelled": "Cancelled",
  "expired": "Expired",
  "cancelReservation": "Cancel reservation?",
  "cancelReservation2": "Cancel reservation",
  "reservationCancelled": "Reservation cancelled",
  "couldnTCancel": "Couldn't cancel",
  "storageReservationQueue": "Storage reservation queue",
  "showFinalized": "Show finalized",
  "refreshQueue": "Refresh queue",
  "noReservationsInTheQueue": "No reservations in the queue.",
  "user2": "User",
  "requested": "Requested",
  "status": "Status",
  "position": "Position",
  "joined": "Joined",
  "actions": "Actions",
  "1Day": "1 day",
  "7Days": "7 days",
  "30Days": "30 days",
  "custom": "Custom",
  "never": "Never",
  "publicLink": "Public link",
  "specificUser": "Specific user",
  "enterAValidDuration": "Enter a valid duration.",
  "selectAnExpiry": "Select an expiry.",
  "shareLinkCreated": "Share link created",
  "sharedWithUser": "Shared with user",
  "shareLinkCopied": "Share link copied",
  "revokeShareLink2": "Revoke share link?",
  "anyoneUsingThisLinkWillLoseAccessImmediately": "Anyone using this link will lose access immediately.",
  "shareLinkRevoked": "Share link revoked",
  "revokeFailed": "Revoke failed",
  "shareLinkEmailed": "Share link emailed",
  "shareFile": "Share file",
  "closeShareDialog": "Close share dialog",
  "shareMethod": "Share method",
  "recipient": "Recipient",
  "theyLlGetAnInAppNotificationWithA": "They'll get an in-app notification with a link to this file.",
  "accessExpiry": "Access expiry",
  "grantExpiry": "Grant expiry",
  "customExpiryAmount": "Custom expiry amount",
  "customExpiryUnit": "Custom expiry unit",
  "hours": "hours",
  "days": "days",
  "theRecipientKeepsAccessUntilYouRevokeThisGrant": "The recipient keeps access until you revoke this grant.",
  "shareWithUser": "Share with user",
  "shareLinkURL": "Share link URL",
  "shareLinkEmailsAreDisabledOnThisServer": "Share link emails are disabled on this server.",
  "emailThisLink": "Email this link",
  "recipientEmailAddress": "Recipient email address",
  "send": "Send",
  "newLink": "New link",
  "linkExpiry": "Link expiry",
  "anyoneWithTheLinkCanAccessThisFileUntil": "Anyone with the link can access this file until you revoke it.",
  "advancedOptions": "Advanced options",
  "maximumUses": "Maximum uses",
  "unlimited2": "Unlimited",
  "theLinkGoesDeadAfterThisManyDownloads": "The link goes dead after this many downloads.",
  "label": "Label",
  "eGSentToDesignTeam": "e.g. Sent to design team",
  "createShareLink": "Create share link",
  "sharing": "Sharing",
  "loading": "Loading...",
  "emailShareLinks": "Email share links",
  "allowAdminsToSendShareLinksByEmailFrom": "Allow admins to send share links by email from this server.",
  "invalidLimit": "Invalid limit",
  "enterAWholeNumberOfGB110000": "Enter a whole number of GB (1–10000).",
  "saveStorageLimit": "Save storage limit",
  "clearLimitRevertToDefault": "Clear limit (revert to default)",
  "storageLimitSet": "Storage limit set",
  "failedToSetLimit": "Failed to set limit",
  "clearStorageLimit": "Clear storage limit?",
  "clearLimit": "Clear limit",
  "storageLimitCleared": "Storage limit cleared",
  "failedToClearLimit": "Failed to clear limit",
  "storageOverview": "Storage overview",
  "refreshStorageAnalytics": "Refresh storage analytics",
  "composition": "Composition",
  "perUserBreakdown": "Per-user breakdown",
  "noUserStorageUsageYet": "No user storage usage yet",
  "total": "Total",
  "central": "Central",
  "home": "Home",
  "backups": "Backups",
  "limit": "Limit",
  "totalConsumed": "Total consumed",
  "storageLocationSaved": "Storage location saved",
  "personalStorageLocation": "Personal storage location",
  "storageRootTemplate": "Storage root template",
  "whereNewAssetsAreStored": "where new assets are stored",
  "saveLocation": "Save location",
  "backupIsTakingLongerThanExpectedCheckBackShortly": "Backup is taking longer than expected — check back shortly.",
  "backupDidNotStart": "Backup did not start",
  "networkError": "Network error",
  "shareSettingsUpdated": "Share settings updated",
  "accessRestricted": "Access restricted",
  "youDoNotHavePermissionToViewThisPage": "You do not have permission to view this page.",
  "needAccess": "Need access?",
  "contactAnAdministratorToRequestPermissions": "Contact an administrator to request permissions.",
  "returnToProfile": "Return to Profile",
  "assetManagementCenter": "Asset Management Center",
  "showSettingsPanel": "Show settings panel",
  "assetSettings": "Asset settings",
  "assetManagementCenterCategory": "Asset Management Center category",
  "backupTypeCreated": "{{backupType}} created",
  "createdForAppLabel": "Created for {{appLabel}}",
  "permanentlyDeleteFileNameThisCannotBeUndone": "Permanently delete \"{{fileName}}\"? This cannot be undone.",
  "userOwnerUserId": "User #{{ownerUserId}}",
  "backUpAppLabelNow": "Back up {{appLabel}} now",
  "deleteAllFileCountBackupsForAppLabel": "Delete all {{fileCount}} backups for {{appLabel}}",
  "viewFileName": "View {{fileName}}",
  "downloadFileName": "Download {{fileName}}",
  "deleteFileName": "Delete {{fileName}}",
  "storageIsFullYouRePositionPositionWeLlNotify": "Storage is full. You're position {{position}} — we'll notify you when space frees and you can upload.",
  "originalNameWillBeRemovedFromTheLibraryActiveShareLinks": "\"{{originalName}}\" will be removed from the library. Active share links for it will stop working.",
  "selectOriginalName": "Select {{originalName}}",
  "viewOriginalName": "View {{originalName}}",
  "viewsOverTheLast14DaysTotalViewsTotal": "Views over the last 14 days, {{totalViews}} total",
  "fileSafeIndexOfLengthOriginalName": "File {{safeIndex}} of {{length}}: {{originalName}}",
  "usernameSAvatarWillBeResetToTheInstanceDefault": "{{username}}'s avatar will be reset to the instance default.",
  "viewingBackupFileFileName": "Viewing backup file {{fileName}}",
  "currentSlot": "Current {{slot}}",
  "storageClampedPercentUsedNearLimit": "Storage {{clampedPercent}}% used — near limit",
  "storageClampedPercentUsed": "Storage {{clampedPercent}}% used",
  "setAsSelected": "Set as {{selected}}",
  "currentTimeOfSafeDuration": "{{currentTime}} of {{safeDuration}}",
  "percentPercent": "{{percent}} percent",
  "playbackSpeedCurrentlyLabel": "Playback speed, currently {{label}}",
  "userUserId": "User #{{userId}}",
  "removeWhoSReservationForRequestedBytesFromTheQueueAny": "Remove {{who}}'s reservation for {{requestedBytes}} from the queue. Any user behind them moves up. They are not notified.",
  "storageLimitForUsernameInGB": "Storage limit for {{username}} in GB",
  "usernameWillRevertToTheGroupOrInstanceDefaultStorage": "{{username}} will revert to the group or instance default storage limit.",
  "failedToLoadShareLinksStatus": "Failed to load share links ({{status}})",
  "failedToLoadStatsStatus": "Failed to load stats: {{status}}",
  "errorStatus": "Error ({{status}})",
  "failedToLoadShareSettingsStatus": "Failed to load share settings ({{status}})",
  "enterANonNegativeNumber": "Enter a non-negative number.",
  "sharedCeilingForAllUsersAndSystemAssetsLeaveBlank": "Shared ceiling for all users and system assets. Leave blank or 0 for unlimited.",
  "eG50": "e.g. 50",
  "uploadsAreUnrestrictedAdminsCanSetACapAnytime": "Uploads are unrestricted. Admins can set a cap anytime.",
  "enterAPositiveNumber": "Enter a positive number.",
  "filesLargerThanThisAreRejectedAtUploadAdminsCan": "Files larger than this are rejected at upload. Admins can lift this anytime.",
  "fullBackup": "Full backup",
  "configBackup": "Config backup",
  "nginxBackup": "Nginx backup",
  "thisUserHasNoApplicationConfigBackups": "This user has no application config backups.",
  "backupsCreatedDuringAppReinstallsOrConfigChangesAppearHere": "Backups created during app reinstalls or config changes appear here. Use \"Back up an app\" to create one on demand.",
  "searchApplications": "Search applications...",
  "default": "Default",
  "storageIsFullWeLlNotifyYouWhenSpaceFrees": "Storage is full. We'll notify you when space frees and you can upload.",
  "viewAccessStats": "View access stats",
  "shareLink": "Share link",
  "thisVideoCouldnTBePreparedForBrowserPlaybackDownload": "This video couldn't be prepared for browser playback. Download to view.",
  "thisFileCouldNotBePreviewed": "This file could not be previewed.",
  "previewNotAvailableDownloadToView": "Preview not available — download to view.",
  "noInlinePreviewIsAvailableForThisFileType": "No inline preview is available for this file type.",
  "assetViewer": "asset viewer",
  "noUsersMatchYourSearch": "No users match your search.",
  "noUsersFound": "No users found.",
  "notSet": "Not set",
  "replace": "Replace",
  "botAvatarUploaded": "Bot avatar uploaded",
  "emailLogoUploaded": "Email logo uploaded",
  "botAvatarResetToDefault": "Bot avatar reset to default",
  "emailLogoRemoved": "Email logo removed",
  "failedToLoadApps": "Failed to load apps",
  "fullBackup2": "Full Backup",
  "uploading": "Uploading…",
  "chooseImage": "Choose image",
  "copied": "Copied",
  "copyPath": "Copy path",
  "failedToSetBrandAsset": "Failed to set brand asset",
  "setBrandAsset": "Set brand asset",
  "playing": "Playing",
  "paused": "Paused",
  "muted": "Muted",
  "pause": "Pause",
  "play": "Play",
  "captionsOn": "Captions on",
  "captionsOff": "Captions off",
  "exitFullscreen": "Exit fullscreen",
  "enterFullscreen": "Enter fullscreen",
  "unmute": "Unmute",
  "mute": "Mute",
  "maximumUsesMustBeBetween1And1000000": "Maximum uses must be between 1 and 1,000,000.",
  "chooseARecipient": "Choose a recipient.",
  "enterAValidEmailAddress": "Enter a valid email address.",
  "copy": "Copy",
  "editLimit": "Edit limit",
  "setLimit": "Set limit",
  "absolutePathWithExactlyOneUserPlaceholderNoSegmentsLetters": "Absolute path with exactly one {user} placeholder. No '..' segments. Letters, digits, dot, dash, underscore, slash only.",
  "failedToLoadCapabilities": "Failed to load capabilities",
  "failedToLoadStorageSettings": "Failed to load storage settings",
  "failedToSaveSettings": "Failed to save settings",
  "backupJobNotFound": "Backup job not found",
  "failedToLoadBackups": "Failed to load backups",
  "failedToDeleteBackup": "Failed to delete backup",
  "failedToCreateBackup": "Failed to create backup",
  "failedToLoadShareLinks": "Failed to load share links",
  "failedToCreateShareLink": "Failed to create share link",
  "failedToShareWithUser": "Failed to share with user",
  "failedToRevokeShareLink": "Failed to revoke share link",
  "failedToSendShareLinkEmail": "Failed to send share link email",
  "failedToLoadStats": "Failed to load stats",
  "failedToLoadAvatars": "Failed to load avatars",
  "failedToUploadAvatar": "Failed to upload avatar",
  "failedToSetActiveAvatar": "Failed to set active avatar",
  "failedToDeleteAvatar": "Failed to delete avatar",
  "failedToLoadReservation": "Failed to load reservation",
  "failedToLoadReservationQueue": "Failed to load reservation queue",
  "failedToCancelReservation": "Failed to cancel reservation",
  "failedToLoadShareSettings": "Failed to load share settings",
  "failedToUpdateShareSettings": "Failed to update share settings",
  "failedToLoadStorageAnalytics": "Failed to load storage analytics",
  "templateMustNotBeEmpty": "Template must not be empty",
  "templateMustBe255CharactersOrLess": "Template must be 255 characters or less",
  "templateMustBeAnAbsolutePath": "Template must be an absolute path",
  "templateMustContainExactlyOneUserPlaceholder": "Template must contain exactly one {user} placeholder",
  "templateMustNotContainPathSegments": "Template must not contain '..' path segments",
  "templateContainsForbiddenCharacters": "Template contains forbidden characters",
  "failedToLoadStorageLocation": "Failed to load storage location",
  "failedToSaveStorageLocation": "Failed to save storage location",
  "failedToSetStorageLimit": "Failed to set storage limit",
  "failedToClearStorageLimit": "Failed to clear storage limit",
  "configDatabaseBackup": "Config & Database Backup",
  "localAssets": "Local Assets",
  "applicationLogos": "Application Logos",
  "avatars": "Avatars",
  "applicationBackups": "Application Backups",
  "manageUploadedImagesDocumentsAndOtherAssets": "Manage uploaded images, documents, and other assets.",
  "logosFaviconAndEmailArtworkForThisInstance": "Logos, favicon, and email artwork for this instance.",
  "brandIconsShownForEachInstalledApplication": "Brand icons shown for each installed application.",
  "userProfilePicturesAcrossTheInstance": "User profile pictures across the instance.",
  "perApplicationConfigBackupsDownloadOrViewTheirContents": "Per-application config backups — download or view their contents.",
  "manageYourProfilePictureAndSavedAvatars": "Manage your profile picture and saved avatars.",
  "appCount": "{{count}} apps",
  "appCount_one": "{{count}} app",
  "appCount_other": "{{count}} apps",
  "expiresIn": "expires {{time}}",
  "sheetTruncated": "Preview limited to {{limits}}. Download the file to view it in full.",
  "previewTruncated": "Preview truncated — showing the first {{size}} KB. Download the file to view it in full.",
  "positionOf": "{{position}} of {{total}}",
  "userCount": "{{count}} users",
  "userCount_one": "{{count}} user",
  "userCount_other": "{{count}} users",
  "reservationWaiting": "Storage is full right now. We’ll notify you when space frees up for your reserved {{size}} and you can upload.",
  "emailSentTo": "Sent to {{recipient}}.",
  "shareLinksCount": "Share links ({{count}})",
  "forCurrentUser": "For you ({{user}}):",
  "countdownNow": "now",
  "countdownLessMinute": "in less than a minute",
  "shareNeverExpires": "Never expires",
  "shareExpirySummary": "Expires {{date}} ({{countdown}})",
  "shareUses": "{{count}} uses",
  "shareUses_one": "{{count}} use",
  "shareUses_other": "{{count}} uses",
  "shareLimitedUses": "{{used}} / {{limit}} uses",
  "storageUsedOf": "{{used}} of {{total}} used",
  "reservationOffered": "Storage freed up for your reserved {{size}}. Upload before your window closes.",
  "reservationOfferedExpires": "Storage freed up for your reserved {{size}}. Upload before your window closes — expires in {{time}}.",
  "reservationPosition": "You’re in line — position {{position}}",
  "sharedWithRecipient": "Shared with {{recipient}} — they’ll get a notification.",
  "storageLocationEffect": "Changing this affects only {{future}} and the SFTP path users browse. Existing files stay where they are.",
  "sheetFirstBytes": "the first {{size}} MB",
  "sheetFirstRows": "the first {{shown}} of {{total}} rows",
  "sheetFirstColumns": "the first {{count}} columns",
  "assetCount": "{{count}} assets",
  "assetCount_one": "{{count}} asset",
  "assetCount_other": "{{count}} assets",
  "deleteAllBackupDescription": "Permanently delete all {{count}} backups for {{app}}? This cannot be undone.",
  "deleteAllBackupDescription_one": "Permanently delete {{count}} backup for {{app}}? This cannot be undone.",
  "deleteAllBackupDescription_other": "Permanently delete all {{count}} backups for {{app}}? This cannot be undone.",
  "deletedBackupCount": "Deleted {{count}} backups",
  "deletedBackupCount_one": "Deleted {{count}} backup",
  "deletedBackupCount_other": "Deleted {{count}} backups",
  "volumePercent": "Volume {{percent}} percent",
  "justNow": "just now",
  "viewCount": "{{count}} views",
  "viewCount_one": "{{count}} view",
  "viewCount_other": "{{count}} views",
  "viewsOnDate": "{{date}}: {{count}} views",
  "viewsOnDate_one": "{{date}}: {{count}} view",
  "viewsOnDate_other": "{{date}}: {{count}} views",
  "deletedBackupsPartial": "Deleted {{removed}} of {{total}} backups",
  "amcUsage": "AMC usage {{percent}}%",
  "amcUsageOver": "AMC usage {{percent}}% — over allowance",
  "storageComposition": "Storage composition: User central {{central}} percent, User home {{home}} percent, System and brand {{system}} percent, Backups {{backup}} percent. Total {{total}}.",
  "userCentral": "User central",
  "userHome": "User home",
  "systemAndBrand": "System and brand",
  "clearStorageLimitFor": "Clear storage limit for {{user}}",
  "storageSummaryLimit": "{{user}} storage {{percent}}% of limit — {{central}} central, {{home}} home, {{backup}} backups",
  "storageSummaryLimitOver": "{{user}} storage {{percent}}% of limit — {{central}} central, {{home}} home, {{backup}} backups — over quota",
  "storageSummaryHeaviest": "{{user}} storage {{percent}}% of heaviest user — {{central}} central, {{home}} home, {{backup}} backups",
  "storageSummaryHeaviestOver": "{{user}} storage {{percent}}% of heaviest user — {{central}} central, {{home}} home, {{backup}} backups — over quota",
  "sharedUploadStore": "shared upload store",
  "logosArtwork": "logos, artwork",
  "perAppConfigs": "per-app configs",
  "shareEmailEnabled": "Share link emails enabled",
  "shareEmailDisabled": "Share link emails disabled",
  "recipientNotifiedWithAsset": "{{asset}} — they’ll get a notification",
  "recipientNotified": "They’ll get a notification",
  "createdAt": "Created {{date}}",
  "shareRevoked": "Revoked",
  "shareExhausted": "Usage limit reached",
  "shareUseLimit": "limited to {{count}} uses",
  "shareUseLimit_one": "limited to {{count}} use",
  "shareUseLimit_other": "limited to {{count}} uses"
} as const;
